import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import ContentViewComponent from '#app/Component/ContentViewComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import { getRoutePathname } from '#app/Handler/RouteHandler';
import Actions from '#app/View/ClientService/OrderClientLitige/components/Actions';
import Information from '#app/View/ClientService/OrderClientLitige/components/Information';
import List from '#app/View/ClientService/OrderClientLitige/components/List';
import { DisputeItem, DisputeState } from '#app/typings/orderClientLitige';

export type Product = {
  id: number;
  name: string;
  amount: number;
  amountReturnReceived: number;
  amountReturnCompliant: number;
  amountRefund: number;
  amountForwarding: number;
  depositAmount: number;
  available: number;
  pricePaidTTC: number;
};

const OrderClientLitige: React.FC = () => {
  const params = useParams<{ uuid: string }>();
  const uuid = params.uuid as string;

  const [dispute, setDispute] = useState<DisputeItem>();
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingProduct, setLoadingProduct] = useState<boolean>(false);
  const [reload, setReload] = useState<boolean>(false);

  useEffect(() => {
    setReload(false);
    setLoading(true);
    setLoadingProduct(true);
    ApiHandler.get<DisputeItem>({ route: 'api_client_service_order_client_litige', params: { uuid } }, (response) => {
      setDispute(response.data);
      setLoading(false);
    });
    ApiHandler.get<Product[]>(
      { route: 'api_client_service_order_client_litige_products', params: { uuid } },
      (response) => {
        setProducts(response.data ?? []);
        setLoadingProduct(false);
      },
    );
  }, [reload, params.uuid]);

  return (
    <ContentViewComponent
      loading={loading}
      breadcrumbs={{
        title: 'Visualisation du litige',
        context: 'Service client',
        links: [{ path: getRoutePathname('client_service_order_client_dispute_list'), label: 'Liste des disputes' }],
      }}
    >
      {dispute && (
        <Information dispute={dispute}>
          {dispute.state !== DisputeState.CLOSED && dispute.state !== DisputeState.ARCHIVED && (
            <Actions
              reload={() => setReload(true)}
              dispute={dispute}
              products={products.filter((product) => product.available > 0)}
            />
          )}
        </Information>
      )}
      <List products={products} loading={loadingProduct} />
    </ContentViewComponent>
  );
};

export default OrderClientLitige;
